export default "__VITE_ASSET__DS9rWOBk__"